// removed by extract-text-webpack-plugin
module.exports = {"toggle":"_2lChr","selected":"_3MRMF","small":"Zff1D"};


//////////////////
// WEBPACK FOOTER
// ./components/Toggle.css
// module id = 453
// module chunks = 3 4 5